import { render, staticRenderFns } from "./BackgroundZones.vue?vue&type=template&id=a6dfb272&scoped=true&"
import script from "./BackgroundZones.vue?vue&type=script&lang=ts&"
export * from "./BackgroundZones.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a6dfb272",
  null
  
)

export default component.exports